import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PersonPlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PersonPlusIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PersonPlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PersonPlusIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PersonPlusIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M12 13c1.382 0 2.764.119 4.145.357 1.687.29 3.06 1.306 3.598 2.665l1.135 2.862c.417 1.05-.27 2.18-1.534 2.526-.107.03-.217.052-.329.069A47.673 47.673 0 0112 22c-2.339 0-4.677-.174-7.015-.521-1.31-.195-2.181-1.234-1.947-2.321a1.73 1.73 0 01.083-.274l1.136-2.862c.539-1.359 1.91-2.375 3.597-2.665A24.402 24.402 0 0112 13zm0 2c-1.292 0-2.586.105-3.884.315-.896.145-1.624.653-1.91 1.333L5 19.51c2.335.327 4.668.49 7 .49a50.46 50.46 0 007-.49l-1.206-2.862c-.286-.68-1.014-1.188-1.91-1.333A24.237 24.237 0 0012 15zm0-13c.711 0 1.388.149 2 .416v2.349A3 3 0 1014.829 8h2.072A5.002 5.002 0 017 7a5 5 0 015-5zm8 0v2h2v2h-2v2h-2V5.999L16 6V4l2-.001V2h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
PersonPlusIcon.displayName = "PersonPlusIcon";
export default PersonPlusIcon;
